import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { GenericDocPeppolPostingQueueContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_fi_generic_doc_peppol_posting_queue_container.model';
@Injectable({
  providedIn: 'root'
})
export class GenericDocPeppolPostingQueueService extends BaseApiTemplateService<GenericDocPeppolPostingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'generic-doc-peppol-posting-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'generic-doc-peppol-posting-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'generic-doc-peppol-posting-queues/backoffice-ep'
    this.httpClient = http;
  }
}
